<template>
  <main class="container">
    <h1 class="page-container-title">{{ adminText('organizationAll.subscribers_list_23b265ba', 'Subscribers List') }}</h1>
    <spinner v-if="loading" />
    <template v-else>
      <section class="mb-32 active-subscription-plans">
        <h2 class="page-container-subtitle">{{ adminText('organizationAll.active_a733b809', 'Active') }}</h2>

        <p v-if="!activeSubscriptionPlans.length" class="no-items-message">
          {{ adminText('organizationAll.no_active_subscription_plans_3b304fa1', 'No active subscription plans.') }}
        </p>

        <div v-else class="items-container">
          <article v-for="plan in activeSubscriptionPlans" :key="plan.id" class="item-card">
            <a
              :href="`/sport-organizations/${organizationSlug}/subscriptions-list/${plan.id}?prepaidCouponName=${plan.name}`"
              class="item-link"
            >
              <p class="item-title">{{ plan.name }}</p>
              <p class="item-date">{{ formatDate(plan.from) }} - {{ formatDate(plan.to) }}</p>
            </a>
          </article>
        </div>
      </section>
      <section>
        <h2 class="page-container-subtitle">{{ adminText('organizationAll.past_405c12fb', 'Past') }}</h2>
        <p v-if="!pastSubscriptionPlans.length" class="no-items-message">
          {{ adminText('organizationAll.no_past_subscription_plans_151fa5ca', 'No past subscription plans.') }}
        </p>
        <div v-else class="items-container">
          <article v-for="plan in pastSubscriptionPlans" :key="plan.id" class="item-card">
            <a
              :href="`/sport-organizations/${organizationSlug}/subscriptions-list/${plan.id}?prepaidCouponName=${plan.name}`"
              class="item-link"
            >
              <p class="item-title">{{ plan.name }}</p>
              <p class="item-date">{{ formatDate(plan.from) }} - {{ formatDate(plan.to) }}</p>
            </a>
          </article>
        </div>
      </section>
    </template>
  </main>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { GET_SPORT_PREPAID_COUPONS } from '@/graphql/prepaidCoupon.graphql'
import tableList from '../../accreditations/attendee-table/list.vue'
import SportSubscriptionDetailsModal from '@/components/organizations/subscriptions/SportSubscriptionDetailsModal.vue'
import tablePagination from '@/components/accreditations/attendee-table/pagination.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'
import spinner from '../../shared/spinner.vue'
import moment from 'moment'

export default {
  mixins: [OrganizationLocalization],
  name: 'sport-subscriptions-list-overview',
  components: {
    SimpleSnackbar,
    tablePagination,
    SportSubscriptionDetailsModal,
    tableList,
    spinner,
  },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      activeSubscriptionPlans: [],
      pastSubscriptionPlans: [],
      loading: true,
    }
  },
  async mounted() {
    await this.fetchSubscriptionPlans()
  },
  methods: {
    async fetchSubscriptionPlans() {
      const {
        data: { getSportOrganizationPrepaidCoupons },
        errors,
      } = await this.$apollo.query({
        query: GET_SPORT_PREPAID_COUPONS,
        variables: {
          organizationSlug: this.organizationSlug,
        },
      })
      if (!errors && getSportOrganizationPrepaidCoupons) {
        this.activeSubscriptionPlans = getSportOrganizationPrepaidCoupons.filter(plan =>
          moment(plan.to).isAfter(moment()),
        )
        this.pastSubscriptionPlans = getSportOrganizationPrepaidCoupons.filter(plan =>
          moment(plan.to).isBefore(moment()),
        )
      }
      this.loading = false
    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY.')
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 64.875rem;
}
.page-container-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.page-container-subtitle {
  color: #ff4c00;
  font-size: 20px;
  font-family: Raleway;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;

  margin-bottom: 0.75rem;
}

.items-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 1150px) {
  .items-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

.no-items-message {
  color: #666666;
  font-size: 18px;
  font-family: Source Sans Pro;
  font-weight: 400;
  line-height: 27px;
  word-wrap: break-word;
}

.item-card {
  background-color: #f5f5f5;
  border-radius: 1.5rem;
}

.item-title {
  margin: 0;
  color: #666666;
  font-size: 24px;
  font-family: Raleway;
  font-weight: 600;
  line-height: 28.8px;
  word-wrap: break-word;
}

.active-subscription-plans .item-title {
  color: #0277bd;
}

.item-date {
  margin: 0;
  color: #666666;
  font-size: 18px;
  font-family: Source Sans Pro;
  font-weight: 400;
  line-height: 27px;
  word-wrap: break-word;
}

.item-link {
  display: block;
  padding: 1rem;
  text-decoration: none;
  color: inherit;
  padding: 2rem;
}
</style>
